<div class="heading">
  <div>
    <h2>تحلیل وضعیت موتور</h2>
    <small>بر اساس زمان‌ها و ولتاژهای گزارش‌شده</small>
  </div>
  <span class="status">داده‌های ثبت‌شده</span>
</div>

<ng-container *ngIf="summary; else empty">
  <div class="state-bars" aria-hidden="true">
    <div *ngFor="let state of states" [class]="state.key" [style.width.%]="state.percent || 0"></div>
  </div>
  <div class="state-cards">
    <div *ngFor="let state of states" class="state-card" [ngClass]="state.key">
      <span class="state-label"><i aria-hidden="true"></i>{{ state.label }}</span>
      <strong dir="ltr">{{ state.duration }}</strong>
      <span *ngIf="state.percent != null; else noPercent"><bdi>{{ state.percent | number:'1.0-0':'en-US' }}%</bdi> از زمان ثبت‌شده</span>
      <ng-template #noPercent><span>سهم زمانی موجود نیست</span></ng-template>
    </div>
  </div>
  <div class="details">
    <div class="detail-row">
      <span>میانگین ولتاژ موتور خاموش</span>
      <strong dir="ltr" *ngIf="summary.AvgEngineOffVoltage != null; else unavailable">{{ summary.AvgEngineOffVoltage | number:'1.2-2':'en-US' }} V</strong>
    </div>
    <div class="detail-row">
      <span>میانگین ولتاژ موتور روشن</span>
      <strong dir="ltr" *ngIf="summary.AvgEngineOnVoltage != null; else unavailable">{{ summary.AvgEngineOnVoltage | number:'1.2-2':'en-US' }} V</strong>
    </div>
    <div class="detail-row">
      <span>اختلاف میانگین دو وضعیت</span>
      <strong dir="ltr" *ngIf="voltageDifference != null; else unavailable">{{ voltageDifference | number:'1.2-2':'en-US' }} V</strong>
    </div>
    <div class="detail-row">
      <span>منبع تحلیل</span>
      <span class="source">خلاصه گزارش روزانه</span>
    </div>
  </div>
</ng-container>

<ng-template #empty><div class="empty" role="status">اطلاعاتی برای تحلیل وضعیت موتور موجود نیست.</div></ng-template>
<ng-template #unavailable><span class="unavailable" aria-label="اطلاعات موجود نیست">—</span></ng-template>
